(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.raf = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.raf = raf;
  exports.doubleRaf = doubleRaf;
  exports.cancelRaf = cancelRaf;
  /**
   * requestAnimationFrame polyfill
   */

  var prev = Date.now();

  /* istanbul ignore next */
  function fallback(fn) {
    var curr = Date.now();
    var ms = Math.max(0, 16 - (curr - prev));
    var id = setTimeout(fn, ms);
    prev = curr + ms;
    return id;
  }

  /* istanbul ignore next */
  var iRaf = window.requestAnimationFrame || fallback;

  /* istanbul ignore next */
  var iCancel = window.cancelAnimationFrame || window.clearTimeout;

  function raf(fn) {
    return iRaf.call(window, fn);
  }

  // double raf for animation
  function doubleRaf(fn) {
    raf(function () {
      raf(fn);
    });
  }

  function cancelRaf(id) {
    iCancel.call(window, id);
  }
});